const target = [
  {
        path: "/target/index",
        component: () => import("@/views/target/index.vue"),
        name: "target",
        meta: { title: "target" },
      },
];

export default target;